// import { lazy } from "@utils/lazy";
// import React from "react";
import Overview from "@pages/Audit/Overview";
import Uploaded from "@pages/Audit/Uploaded";
import Completed from "@pages/Audit/Completed";
import NotUploaded from "@pages/Audit/NotUploaded";
import UploadedDetails from "@pages/Audit/Uploaded/Uploaded-Details";
import DashboardUploadedDetails from "@pages/Audit/Dashboard-Audit-Details";
import AuditHeadCount from "@pages/Audit/Uploaded/Uploaded-Details/HeadCount";

export const AuditRoutes = [
  // /audit
  {
    path: "/audit/overview",
    name: "audit_manage_audit",
    component: Overview,
  },
  {
    path: "/audit/vendor-audit",
    name: "audit_vendor_audit",
    component: Uploaded,
  },

  {
    path: "/audit/vendor/uploaded",
    name: "audit_vendor_audit_uploaded",
    component: Uploaded,
  },
  {
    path: "/audit/vendor/uploaded/details",
    name: "audit_manage_audit",
    component: UploadedDetails,
  },
  {
    path: "/audit/vendor/completed",
    name: "audit_vendor_audit_completed",
    component: Completed,
  },
  {
    path: "/audit/vendor/not-uploaded",
    name: "audit_vendor_audit_not_completed",
    component: NotUploaded,
  },
  {
    path: "/audit/details/:id/:date/:route/:name",
    name: "audit_vendor_audit",
    component: UploadedDetails,
  },
  {
    path: "/audit/details/headcount/:id/:date/:route/:name",
    name: "audit_vendor_audit",
    component: AuditHeadCount,
  },
  {
    path: "/audit/details/:date/:upload/:audit",
    name: "audit_vendor_audit",
    component: DashboardUploadedDetails,
  },
];
